import { render, staticRenderFns } from "./FilterEditSubPage.vue?vue&type=template&id=0fd80756&scoped=true&"
import script from "./FilterEditSubPage.vue?vue&type=script&lang=js&"
export * from "./FilterEditSubPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd80756",
  null
  
)

/* custom blocks */
import block0 from "./FilterEditSubPage.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fd80756')) {
      api.createRecord('0fd80756', component.options)
    } else {
      api.reload('0fd80756', component.options)
    }
    module.hot.accept("./FilterEditSubPage.vue?vue&type=template&id=0fd80756&scoped=true&", function () {
      api.rerender('0fd80756', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/filter-management/FilterEditSubPage.vue"
export default component.exports